import { render } from "./UserAgreements.vue?vue&type=template&id=e33627a0&scoped=true"
import script from "./UserAgreements.vue?vue&type=script&lang=js"
export * from "./UserAgreements.vue?vue&type=script&lang=js"

import "./UserAgreements.vue?vue&type=style&index=0&id=e33627a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e33627a0"]])

export default __exports__